import ReactMarkdown from "react-markdown";

const C = {
  h1: (p) => <h2 className="mt-6 mb-2 font-heading text-2xl font-bold tracking-tight text-slate-900" {...p} />,
  h2: (p) => <h3 className="mt-6 mb-2 font-heading text-xl font-semibold text-slate-900" {...p} />,
  h3: (p) => <h4 className="mt-5 mb-1.5 font-heading text-base font-semibold text-slate-900" {...p} />,
  p: (p) => <p className="my-3 leading-relaxed text-slate-700" {...p} />,
  ul: (p) => <ul className="my-3 ml-5 list-disc space-y-1 text-slate-700 marker:text-green-600" {...p} />,
  ol: (p) => <ol className="my-3 ml-5 list-decimal space-y-1 text-slate-700" {...p} />,
  a: (p) => <a className="text-green-700 underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
  strong: (p) => <strong className="font-semibold text-slate-900" {...p} />,
  blockquote: (p) => <blockquote className="my-4 border-l-4 border-green-500 bg-green-50/60 px-4 py-2 text-slate-700" {...p} />,
};

export const LessonMarkdown = ({ children }) => (
  <article className="mb-6 rounded-xl border border-border bg-white px-6 py-4" data-testid="lesson-body">
    <ReactMarkdown components={C}>{children}</ReactMarkdown>
  </article>
);
